import './ant-table.css';
import './communityReviews.css';
import 'antd/dist/antd.less';
import { Button, Icon, Input, Modal, Spin, Table } from 'antd';
import { ClickableReviewText } from '../UI/ClickableReviewText';
import { CommunitiesHelpers } from '../../communities.js';
import { ContactIconHeader } from '../UI/ContactIconHeader';
import { ContactIndicator } from '../Contacts/ContactIndicator';
import { GetUserClassificationName } from '../../org/OrgClassification';
import { ReviewRatingWithMuchLove } from '../UI/ReviewRatingWithMuchLove';
import { Translate } from 'react-localize-redux';
import { UserListLink } from '../UI/UserListLink';
import { UserTitleReview } from '../User/UserTitleReview';
import api from '../../Api';
import CommunityReviewsTableRow from './CommunityReviewsTableRow';
import React from 'react';
import ReviewDate from '../UI/ReviewDate';
import UserAvatar from 'treeline-react-core-components/UserAvatar';

export class CommunityReviews extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			visible: false,
			dataRetrieved: false,
			reviewRetrieving: false,
			expandedRowRender: this.expandedRowRender,
			searchText: '',
		};
	}

	componentDidMount() {
		var communityId = this.props.match.params.communityId;
		var daysBack = this.props.match.params.reviewsCreatedDateMaxDaysBack;

		this.fetchRequest = api.cancelableGet(
			`/api/v1/affiliations/${communityId}/reviews/${daysBack}`, //`
		);
		const { promise } = this.fetchRequest;

		promise.then(res => {
			let reviewsBySku = {};
			res.reviews.forEach(function(review) {
				if (reviewsBySku.hasOwnProperty(review.sku)) {
					reviewsBySku[review.sku].push(review);
				} else {
					reviewsBySku[review.sku] = [review];
				}
			});
			let rows = [];
			for (let sku in reviewsBySku) {
				rows.push({
					key: sku,
					reviews: reviewsBySku[sku],
					orgInfo: res.organizationsById,
					userInfo: res.usersById,
					userAvatars: res.userAvatarsByAppUserId,
					contactsList: res.contactAppUserIds,
					contactCounts: res.contactCountsByAppUserId,
					productInfo: res.productsBySku,
					productImages: res.productImageUrisBySku,
				});
			}

			rows = this.sortTitlesByMostRecentReview(rows);

			let mainColumns = this.buildMainColumns();
			this.setState({
				columns: mainColumns,
				data: rows,
				dataRetrieved: true,
			});
		});
	}

	componentWillUnmount() {
		this.fetchRequest.cancel();
	}

	sortTitlesByMostRecentReview(titleRows) {
		return titleRows.sort((a, b) => {
			const mostRecentA = this.getMostRecentReviewDate(a);
			const mostRecentB = this.getMostRecentReviewDate(b);
			return mostRecentB - mostRecentA;
		});
	}

	getMostRecentReviewDate(titleEntry) {
		const { reviews } = titleEntry;
		const dates = reviews.map(r => {
			return new Date(r.createdDate);
		});
		return new Date(Math.max.apply(null, dates));
	}

	handleCancel = () => {
		this.setState({
			visible: false,
		});
	};

	buildMainColumns = () => {
		let mainColumns = [
			{
				title: <span>&nbsp;</span>,
				key: 'review',
				render: row => {
					return (
						<CommunityReviewsTableRow
							row={row}
							communityId={this.props.match.params.communityId}
							reviewsCreatedDateMaxDaysBack={
								this.props.match.params
									.reviewsCreatedDateMaxDaysBack
							}
							searchText={this.state.searchText}
							setUserTitleReviewModalState={
								this.setUserTitleReviewModalState
							}
						/>
					);
				},
				...this.getTitleColumnSearchProps(),
			},
		];
		return mainColumns;
	};

	buildExpandedRowColumns = () => {
		let expandedRowColumns = [
			{
				title: '',
				dataIndex: 'profile',
				render: row => (
					<UserAvatar
						userInitials={row.initials}
						avatarUri={row.url || null}
						displayName={row.displayName}
						avatarSizeClass={`avatar-${row.size}`} //`
					/>
				),
			},
			{
				title: <Translate id="user" />,
				dataIndex: 'user',
				className: 'pad-1',
				defaultSortOrder: 'descend',
				sorter: (a, b) =>
					('' + a.user.userInfo.lastName).localeCompare(
						b.user.userInfo.lastName,
					),
				render: row => {
					return (
						<div>
							<UserListLink
								userId={row.userId}
								userName={row.userInfo.fullName}
								orgName={row.orgInfo.name}
								orgId={row.userInfo.orgID}
								userListLinkClass="text-small"
								includeOrg
								linksOff
							/>
						</div>
					);
				},
			},
			{
				title: <Translate id="type" />,
				dataIndex: 'type',
				sorter: (a, b) => ('' + a.type).localeCompare(b.type),
				render: row => <div>{row}</div>,
			},
			{
				title: <Translate id="rating" />,
				dataIndex: 'rating',
				defaultSortOrder: 'descend',
				sorter: (a, b) => a.rating.assessment - b.rating.assessment,
				render: row => (
					<ReviewRatingWithMuchLove
						rating={row.assessment}
						doPadLeftMuchLove
						doUseTextLarge
					/>
				),
			},
			{
				title: <Translate id="review" />,
				dataIndex: 'review',
				sorter: (a, b) => a.review.reviewed - b.review.reviewed,
				render: row => {
					return (
						<div className="text-small">
							<ReviewDate reviewedDate={row.reviewed} />
							<ClickableReviewText
								appUserId={row.appUserId}
								sku={row.sku}
								reviewText={row.reviewText}
								communityId={
									this.props.match.params.communityId
								}
								reviewsCreatedDateMaxDaysBack={
									this.props.match.params
										.reviewsCreatedDateMaxDaysBack
								}
								setUserTitleReviewModalState={
									this.setUserTitleReviewModalState
								}
							/>
						</div>
					);
				},
			},
			{
				title: () => <ContactIconHeader />,
				dataIndex: 'contact',
				sorter: (a, b) => a.contact.sortCount - b.contact.sortCount,
				render: row => (
					<ContactIndicator
						contactCount={row.count}
						isMyContact={row.isMyContact}
						className="contact-count-display"
					/>
				),
			},
		];
		return expandedRowColumns;
	};

	expandedRowRender = row => {
		let expandedRowColumns = this.buildExpandedRowColumns();
		const rows = [];
		for (let i = 0; i < row.reviews.length; i++) {
			let review = row.reviews[i];
			if (
				review.appUserId in row.userInfo &&
				row.userInfo[review.appUserId].orgID.toLowerCase() in
					row.orgInfo
			) {
				let userInfo = row.userInfo[review.appUserId];
				let orgInfo = row.orgInfo[userInfo.orgID.toLowerCase()];
				let userAvatar = row.userAvatars[review.appUserId];
				rows.push({
					key: i,
					profile: userAvatar,
					user: {
						userId: review.appUserId,
						userInfo: userInfo,
						orgInfo: orgInfo,
					},
					type: GetUserClassificationName(orgInfo, userInfo),
					rating: {
						assessment: review.rating,
					},
					review: {
						reviewed: new Date(review.createdDate),
						reviewText: review.abstract,
						appUserId: review.appUserId,
						sku: review.sku,
					},
					contact: {
						sortCount:
							review.appUserId in row.contactCounts
								? row.contactCounts[review.appUserId]
								: 0,
						count: this.getContactCount(
							review.appUserId,
							row.contactCounts,
						),
						isMyContact: this.isMyContact(
							review.appUserId,
							row.contactsList,
						),
					},
				});
			}
		}

		rows.sort((a, b) => b.review.reviewed - a.review.reviewed);

		return (
			<Table
				columns={expandedRowColumns}
				dataSource={rows}
				pagination={false}
			/>
		);
	};

	getContactCount(appUserId, contactCounts) {
		if (appUserId in contactCounts) {
			return contactCounts[appUserId];
		} else {
			return '-';
		}
	}

	isMyContact(appUserId, contacts) {
		return contacts && contacts.includes(appUserId);
	}

	getTitleColumnSearchProps = () => ({
		filterDropdown: ({
			setSelectedKeys,
			selectedKeys,
			confirm,
			clearFilters,
		}) => (
			<div style={{ padding: 8 }}>
				<Input
					ref={node => {
						this.searchInput = node;
					}}
					placeholder={'Search by Title'}
					value={selectedKeys[0]}
					onChange={e =>
						setSelectedKeys(e.target.value ? [e.target.value] : [])
					}
					onPressEnter={() =>
						this.handleSearch(selectedKeys, confirm)
					}
					style={{ width: 188, marginBottom: 8, display: 'block' }}
				/>
				<Button
					type="primary"
					onClick={() => this.handleSearch(selectedKeys, confirm)}
					icon="search"
					size="small"
					style={{ width: 90, marginRight: 8 }}>
					Search
				</Button>
				<Button
					onClick={() => this.handleReset(clearFilters)}
					size="small"
					style={{ width: 90 }}>
					Reset
				</Button>
			</div>
		),
		filterIcon: filtered => (
			<Icon
				type="search"
				style={{ color: filtered ? '#1890ff' : undefined }}
			/>
		),
		onFilter: (value, record) =>
			record.productInfo[record.key].name
				.toLowerCase()
				.includes(value.toLowerCase()),
		onFilterDropdownVisibleChange: visible => {
			if (visible) {
				setTimeout(() => this.searchInput.select());
			}
		},
	});

	handleSearch = (selectedKeys, confirm) => {
		confirm();
		this.setState({ searchText: selectedKeys[0] });
	};

	handleReset = clearFilters => {
		clearFilters();
		this.setState({ searchText: '' });
	};

	setUserTitleReviewModalState = state => {
		this.setState(state);
	};

	render() {
		return (
			<div>
				{this.state.dataRetrieved ? (
					<Spin spinning={this.state.reviewRetrieving}>
						<div className="flex-container flex-column">
							<div className="community-reviews-table-container">
								<Table
									className="scrollable-ant-table"
									size="small"
									columns={this.state.columns}
									dataSource={this.state.data}
									pagination={{
										pageSize: 3,
									}}
									expandedRowRender={
										this.state.expandedRowRender
									}
									rowClassName={(record, index) =>
										CommunitiesHelpers.getStripedClassName(
											index,
										)
									}
								/>
							</div>
						</div>
					</Spin>
				) : (
					<Spin spinning={this.state.loading}>
						<div className="middle-frame" />
					</Spin>
				)}
				<Modal
					title={
						<Translate
							id="review_of_x"
							data={{ titleName: this.state.titleName }}
						/>
					}
					visible={this.state.visible}
					footer={null}
					onCancel={this.handleCancel}
					width={700}>
					<UserTitleReview
						sku={this.props.match.params.sku}
						appUserId={this.state.appUserId}
						titleName={this.state.titleName}
						reviewText={this.state.reviewText}
						rating={this.state.rating}
						userAvatar={this.state.userAvatar}
						userName={this.state.userName}
						createdDate={this.state.createdDate}
						orgName={this.state.orgName}
						orgLocation={this.state.orgLocation}
						assessments={this.state.assessments}
					/>
				</Modal>
			</div>
		);
	}
}
